import { render, staticRenderFns } from "./AnotherPendant.vue?vue&type=template&id=47ef06c9&scoped=true&"
import script from "./AnotherPendant.vue?vue&type=script&lang=js&"
export * from "./AnotherPendant.vue?vue&type=script&lang=js&"
import style0 from "./AnotherPendant.vue?vue&type=style&index=0&id=47ef06c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef06c9",
  null
  
)

component.options.__file = "AnotherPendant.vue"
export default component.exports